import { CasRHFSelect, CasSelect, componentProps, CasEntitySelectProps } from 'src/compass/shared/components';
import useRetrieveEntityListOptions, {
  EntityListOptionsProps,
} from 'src/compass/shared/hooks/reactQuery/useRetrieveEntityListOptions';

export function useRetrieveSelectListOptions(entity: string, props: EntityListOptionsProps) {
  return useRetrieveEntityListOptions({
    entity,
    includeAllOption: props.includeAllOption,
    includeNoneOption: props.includeNoneOption,
    includeEmptyOption: props.includeEmptyOption,
    params: props.params,
    staleTime: props.staleTime,
  });
}

export function CasEntityRHFSelect(entity: string, props: CasEntitySelectProps) {
  const { options, isLoading } = useRetrieveSelectListOptions(entity, props);
  return <CasRHFSelect loading={isLoading} options={options} {...props} />;
}

export function CasEntitySelect(entity: string, props: componentProps) {
  const { options } = useRetrieveSelectListOptions(entity, props);
  return <CasSelect options={options} {...props} />;
}
